import React, { useEffect, useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useChatbot } from '../context/ChatbotContext';

const ChatButton = () => {
    const { isDarkMode } = useTheme();
    const {
        toggleChat, 
        hasShownWelcome,
        setHasShownWelcome,
        setMessages,
        setShowOptions
    } = useChatbot();
    const [showBubble, setShowBubble] = useState(false);

    useEffect(() => {
        if (!hasShownWelcome) {
            const timer = setTimeout(() => {
                setShowBubble(true);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [hasShownWelcome]);

    const handleMaybeLater = () => {
        setShowBubble(false);
        // Don't set hasShownWelcome to true here, so the welcome message will show when they open the chat later
    };

    const handleTellMeMore = () => {
        setShowBubble(false);
        toggleChat();
        // Add a small delay to ensure the chat is open before adding the message
        setTimeout(() => {
            setMessages([{ 
                role: 'assistant', 
                content: "Welcome! I can help you understand how this calculator works."
            }]);
            setShowOptions(true);
        }, 100);
    };

    return (
        <div className="fixed bottom-4 right-4">
            {/* Welcome Bubble */}
            <div 
                className={`absolute bottom-16 right-0 w-64 p-3 rounded-lg shadow-lg transition-all duration-300 ease-in-out transform ${
                    showBubble 
                        ? 'opacity-100 translate-y-0' 
                        : 'opacity-0 translate-y-2 pointer-events-none'
                } ${
                    isDarkMode
                        ? 'bg-gray-800 text-white border border-gray-700'
                        : 'bg-white text-gray-900 border border-gray-200'
                }`}
            >
                <div className="relative">
                    <p className="text-sm">
                        Hi! I can help you understand how this calculator works. Would you like to know more?
                    </p>
                    <button
                        onClick={handleTellMeMore}
                        className={`mt-2 w-full py-1 px-3 rounded text-sm font-medium transition-colors ${
                            isDarkMode
                                ? 'bg-cyan-500 hover:bg-cyan-600 text-white'
                                : 'bg-cyan-500 hover:bg-cyan-600 text-white'
                        }`}
                    >
                        Yes, tell me more
                    </button>
                    <button
                        onClick={handleMaybeLater}
                        className={`mt-1 w-full py-1 px-3 rounded text-sm font-medium transition-colors ${
                            isDarkMode
                                ? 'bg-gray-700 hover:bg-gray-600 text-gray-300'
                                : 'bg-gray-200 hover:bg-gray-300 text-gray-700'
                        }`}
                    >
                        Maybe later
                    </button>
                    {/* Triangle pointer */}
                    <div className={`absolute -bottom-2 right-2 w-4 h-4 transform rotate-45 ${
                        isDarkMode ? 'bg-gray-800' : 'bg-white'
                    }`} />
                </div>
            </div>

            {/* Chat Button */}
            <button
                onClick={toggleChat}
                className={`w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-colors ${
                    isDarkMode
                        ? 'bg-cyan-500 hover:bg-cyan-600 text-white'
                        : 'bg-cyan-500 hover:bg-cyan-600 text-white'
                }`}
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                </svg>
            </button>
        </div>
    );
};

export default ChatButton; 